"use script";

angular.module("customer")
.constant("ORDER_DEADLINE_LATE_HOURS", 2);



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-partnership/user-partnership.constants.js
// module id = 889
// module chunks = 0